export enum TransportType {
  A_TO_B = 'A_TO_B',
  MULTI = 'MULTI',
}
